import styles from './ButtonLink.module.scss'
import React from 'react'

type Props = {
  onClick?: () => void
  label: string,
  icon?: React.FunctionComponent<any>,
  disabled?: boolean,
}

const ButtonLink = (props: Props) => {
  const IconComponent = props.icon as React.ElementType

  const onClickHandler = () => {
    if (props.onClick === undefined) return

    props.onClick()
  }

  return (
    <button
      onClick={onClickHandler}
      disabled={props.disabled}
      className={styles.component}
    >
      {props.icon && (
        <IconComponent
          className={styles.icon}
        />
      )}
      {props.label}
    </button>
  )
}

export default ButtonLink